<div class="local-login">
  <yds-card>
    <div class="local-login__card-content">
      <h1 class="gl-page__title">Login</h1>

      <p class="local-login__environment">Environment: {{ environmentName }}</p>

      <yds-dropdown
        [label]="'Tenant'"
        [items]="tenantOptions()"
        [value]="selectedTenant()"
        [required]="true"
        [placeholder]="'Selecteer tenant'"
        [hasError]="!selectedTenant()"
        [errorMsg]="'Selecteer een tenant om in te loggen.'"
        [allowClear]="false"
        (valueChange)="onTenantChange($event)"
      />

      <yds-combobox
        [label]="'Account'"
        [items]="accountOptions"
        [value]="selectedAccount()"
        [required]="true"
        [placeholder]="'Selecteer account'"
        [hasError]="!selectedAccount()"
        [errorMsg]="'Selecteer een account om in te loggen.'"
        (valueChange)="onAccountChange($event)"
      />

      <div class="gl-form__actions local-login__actions">
        <yds-button variant="primary" [disabled]="!canLogin() || isLoggingIn()" (click)="login()">
          @if (isLoggingIn()) {
            <yds-spinner size="sm" />
          }
          Login
        </yds-button>
      </div>
    </div>
  </yds-card>
</div>
